import React from 'react';
import SignupForm from '../components/SignupForm';
import MenuHeader from '../components/MenuHeader';
import { Link } from 'react-router-dom';
import { FaShoppingBasket, FaTruck, FaClock } from 'react-icons/fa';
import { GiWashingMachine } from 'react-icons/gi';

export default function SignupPage() {
  const scrollToSignup = () => {
    document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Only one set of top right buttons */}

      <MenuHeader />
      <main>
        <section className="section">
          <div className="container">
            <h2>How it works</h2>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', maxWidth: 400 }}>
              <div className="card">
                <div className="icon"><FaShoppingBasket /></div>
                <div style={{ fontWeight: 800, marginTop: 10 }}>Book a pickup</div>
                <p className="small">Tell us your preferred pickup day and we’ll confirm by email.</p>
              </div>
              <div className="card">
                <div className="icon"><GiWashingMachine /></div>
                <div style={{ fontWeight: 800, marginTop: 10 }}>Laundry done right</div>
                <p className="small">Quality wash, dry & fold. Items handled like they’re ours.</p>
              </div>
              <div className="card">
                <div className="icon"><FaTruck /></div>
                <div style={{ fontWeight: 800, marginTop: 10 }}>Delivered back</div>
                <p className="small">We deliver back within 48 hours (most areas).</p>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="signup">
          <div className="container">
            <h2>Sign up</h2>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '32px' }}>
              <div className="card" style={{ minWidth: 400, alignItems: 'flex-start' }}>
                <SignupForm />
              </div>
              <div className="card" style={{ minWidth: 300 }}>
                <div style={{ fontWeight: 800 }}>What you get</div>
                <ul style={{ margin: '12px 0 0', paddingLeft: 18, color: 'var(--ff-muted)', lineHeight: 1.7 }}>
                  <li>Doorstep pickup & delivery</li>
                  <li>Simple monthly plans</li>
                  <li>Senior discount available (60+)</li>
                  <li>Dublin-first rollout</li>
                </ul>
                <div style={{ marginTop: 14 }} className="small">
                  After you submit, you’ll be redirected to secure Stripe Checkout.
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer className="footer">
          <div className="container">
            © {new Date().getFullYear()} FreshFold Ireland • <a href="/terms">Terms</a> • <a href="/privacy">Privacy</a>
          </div>
        </footer>
      </main>
    </>
  );
}
